// NOTE: Modifying this file manually can cause the CLI tool to not work properly.

import HeaderContainer from './containers/HeaderContainer';
import AccountContainer from './containers/Account/AccountContainer';
import FooterContainer from './containers/FooterContainer';
import PressHeroContainer from './containers/PressHeroContainer';
import CardThreeUpContainer from './containers/CardThreeUpContainer';
import RecentPressContainer from './containers/RecentPressContainer';
import OwlCTAContainer from './containers/OwlCTAContainer';
import HomeHeroContainer from './containers/HomeHeroContainer';
import SeeItAllContainer from './containers/SeeItAllContainer';
import HomeMeetingOwlProContainer from './containers/HomeMeetingOwlProContainer';
import HomeConnectRoomContainer from './containers/HomeConnectRoomContainer';
import CollabEnhancementsContainer from './containers/CollabEnhancementsContainer';
import BuildARoomContainer from './containers/BuildARoomContainer';
import FourLogosContainer from './containers/FourLogosContainer';
import HomeWFAIRLContainer from './containers/HomeWFAIRLContainer';
import HomeSolutionsContainer from './containers/HomeSolutionsContainer';
import ImageHeroContainer from './containers/ImageHeroContainer';
import HeroProductListingContainer from './containers/HeroProductListingContainer';
import PDPSubNavContainer from './containers/PDP/PDPSubNavContainer';
import PDPHeroContainer from './containers/PDP/PDPHeroContainer';
import PDPJumpLinksContainer from './containers/PDP/PDPJumpLinksContainer';
import BackgroundProductListingContainer from './containers/BackgroundProductListingContainer';
import FeaturedReviewsContainer from './containers/FeaturedReviewsContainer';
import MultiProductListingContainer from './containers/MultiProductListingContainer';
import AccessoriesContainer from './containers/AccessoriesContainer';
import PDPImmersiveExperienceContainer from './containers/PDP/PDPImmersiveExperienceContainer';
import PDPLargeRoomsContainer from './containers/PDP/PDPLargeRoomsContainer';
import PDPDelightfulContainer from './containers/PDP/PDPDelightfulContainer';
import OwlSightingContainer from './containers/OwlSightingContainer';
import PDPUnboxContainer from './containers/PDP/PDPUnboxContainer';
import ProductComparisonContainer from './containers/ProductComparisonContainer';
import BundlesContainer from './containers/BundlesContainer';
import OwlDemoContainer from './containers/OwlDemoContainer';
import PDPContentContainer from './containers/PDP/PDPContentContainer';
import AboutHeroContainer from './containers/AboutHeroContainer';
import CareersHeroContainer from './containers/CareersHeroContainer';
import CareersBenefitsContainer from './containers/CareersBenefitsContainer';
import CareersOfficeContentContainer from './containers/CareersOfficeContentContainer';
import CareersFeaturedEmployeesContainer from './containers/CareersFeaturedEmployeesContainer';
import AboutInnovationContainer from './containers/AboutInnovationContainer';
import AboutWFAEverydayContainer from './containers/AboutWFAEverydayContainer';
import EightLogosContainer from './containers/EightLogosContainer';
import AboutOwlQuoteContainer from './containers/AboutOwlQuoteContainer';
import AboutPressSnippetContainer from './containers/AboutPressSnippetContainer';
import IndustrySpecificContainer from './containers/IndustrySpecificContainer';
import ResellersBenefitsContainer from './containers/ResellersBenefitsContainer';
import ResellersPartnerPortalContainer from './containers/ResellersPartnerPortalContainer';
import ResellersCommonQuestionsContainer from './containers/ResellersCommonQuestionsContainer';
import ResellersApplicationFormContainer from './containers/ResellersApplicationFormContainer';
import FeaturedShopContainer from './containers/FeaturedShopContainer';
import LoginContainer from './containers/Account/LoginContainer';
import RegisterContainer from './containers/Account/RegisterContainer';
import OrderSummaryPageContainer from './containers/Account/OrderSummaryContainer';
import CartContainer from './containers/Cart/CartContainer';
import CartBannerContainer from './containers/CartBannerContainer';
import ScheduleDemoFormContainer from './containers/ScheduleDemoFormContainer';
import CookieBannerContainer from './containers/CookieBannerContainer';
import BeaconButtonContainer from './containers/BeaconButtonContainer';
import ErrorPageContainer from './containers/ErrorPageContainer';
import ReusableFormContainer from './containers/ReusableFormContainer';
import QuizKitCustomLogicContainer from './containers/QuizKitCustomLogicContainer';
import ShopFeaturedProductContainer from './containers/ShopFeaturedProductContainer';
import ShopHeaderContainer from './containers/ShopHeaderContainer';

export const CONTAINERS = {
    'Header': HeaderContainer,
    'Account': AccountContainer,
    'Footer': FooterContainer,
    'PressHero': PressHeroContainer,
    'CardThreeUp': CardThreeUpContainer,
    'OwlCTA': OwlCTAContainer,
    'RecentPress': RecentPressContainer,
    'HomeHero': HomeHeroContainer,
    'SeeItAll': SeeItAllContainer,
    'HomeMeetingOwlPro': HomeMeetingOwlProContainer,
    'HomeConnectRoom': HomeConnectRoomContainer,
    'CollabEnhancements': CollabEnhancementsContainer,
    'BuildARoom': BuildARoomContainer,
    'FourLogos': FourLogosContainer,
    'HomeWFAIRL': HomeWFAIRLContainer,
    'HomeSolutions': HomeSolutionsContainer,
    'ImageHero': ImageHeroContainer,
    'HeroProductListing': HeroProductListingContainer,
    'PDPSubNav': PDPSubNavContainer,
    'PDPHero': PDPHeroContainer,
    'PDPJumpLinks': PDPJumpLinksContainer,
	'BackgroundProductListing': BackgroundProductListingContainer,
	'FeaturedReviews': FeaturedReviewsContainer,
	'MultiProductListing': MultiProductListingContainer,
	'Accessories': AccessoriesContainer,
    'PDPImmersiveExperience': PDPImmersiveExperienceContainer,
    'PDPLargeRooms': PDPLargeRoomsContainer,
    'PDPDelightful': PDPDelightfulContainer,
    'OwlSighting': OwlSightingContainer,
    'PDPUnbox': PDPUnboxContainer,
    'ProductComparison': ProductComparisonContainer,
    'Bundles': BundlesContainer,
    'OwlDemo': OwlDemoContainer,
    'PDPContent': PDPContentContainer,
	'AboutHero': AboutHeroContainer,
    'CareersHero': CareersHeroContainer,
    'CareersBenefits': CareersBenefitsContainer,
    'CareersOfficeContent': CareersOfficeContentContainer,
    'CareersFeaturedEmployees': CareersFeaturedEmployeesContainer,
    'IndustrySpecific': IndustrySpecificContainer,
    'AboutInnovation': AboutInnovationContainer,
    'AboutWFAEveryday': AboutWFAEverydayContainer,
    'EightLogos': EightLogosContainer,
    'AboutOwlQuote': AboutOwlQuoteContainer,
    'AboutPressSnippet': AboutPressSnippetContainer,
    'ResellersBenefits': ResellersBenefitsContainer,
    'ResellersPartnerPortal': ResellersPartnerPortalContainer,
    'ResellersCommonQuestions': ResellersCommonQuestionsContainer,
    'ResellersApplicationForm': ResellersApplicationFormContainer,
    'FeaturedShop': FeaturedShopContainer,
    'Cart': CartContainer,
	'Login': LoginContainer,
	'Register': RegisterContainer,
    'OrderSummary': OrderSummaryPageContainer,
    'CartBanner': CartBannerContainer,
    'ScheduleDemoForm': ScheduleDemoFormContainer,
    'CookieBanner': CookieBannerContainer,
	'BeaconButton': BeaconButtonContainer,
    'ErrorPage': ErrorPageContainer,
    'ReusableForm': ReusableFormContainer,
    'QuizKitCustomLogic': QuizKitCustomLogicContainer,
    'ShopFeaturedProduct': ShopFeaturedProductContainer,
    'ShopHeader': ShopHeaderContainer,
};

